import React, { useState, useEffect } from 'react';
import { Container } from './styles.js';
import Movies from './movies/index.js';
import CarouselMovie from './carousel/index.js';

function SearchMovieType({ user, setBackgroundNav }) {
  const [movies, setMovies] = useState([]);
  const [featuredMovie, setFeaturedMovie] = useState(null);

  useEffect(()=> {
      window.scrollTo(0,0)
  }, [ ]);

  // Escolhe um filme aleatório dos que possuem `main_movie === true`
  useEffect(() => {
    if (movies?.length > 0) {
      const filteredMovies = movies.filter(movie => movie.main_movie === true);
      
      if (filteredMovies?.length > 0) {
        const randomMovie = filteredMovies[Math.floor(Math.random() * filteredMovies?.length)];
        setFeaturedMovie(randomMovie);
      }}

    document.querySelector('meta[name="theme-color"]').setAttribute('content', "#202020")
    document.title = 'Moov Pro';
    setBackgroundNav("#202020")
  }, [movies]);

  return (
    <Container>
      <main>
        {featuredMovie && <CarouselMovie movie={featuredMovie} />}
        <Movies user={user} movies={movies} setMovies={setMovies} />
      </main>
    </Container>
  );
}

export default SearchMovieType;
